module.exports = __webpack_public_path__ + "img/takeoff-flight.56eff572.svg";